/*
* 店铺签名设置
* */

import { get, post, postJson,put,postUrl } from './axios'

const RESOURCE_BASE_PATH = '/tb-order'

//  订单列表查询
export const getTbOrder = p => postJson(`${RESOURCE_BASE_PATH}/`, p);

//  查询订单详情
export const getOrderDetail = p => get(`${RESOURCE_BASE_PATH}/${p}`);

//  添加订单
export const addOrder = p => postJson(`${RESOURCE_BASE_PATH}/add-order`, p);

//  根据订单号查询订单敏感信息
export const sensitive = p => get(`${RESOURCE_BASE_PATH}/sensitive`, p);

//  查询订单ID集合
export const getOrderIds = p => postJson(`${RESOURCE_BASE_PATH}/orderIds`, p);

//  查询订单ID集合
export const addCrowd = p => postJson(`${RESOURCE_BASE_PATH}/crowd`, p);

//  预售订单发送pop分页接口
export const tbOrderPresell = p => postJson(`/tbOrderPresell/page`, p);

// 预售
export const Presellpop = p => postJson(`/tbOrderPresell/orderIds`, p);

// 预售
export const LabelByQueryPop = p => put(`/shopBuyer/batchAddLabelByQuery`, p);

// 订单添加
export const orderProgress = p => postJson(`/tb-order/add-order/progress`, p);
